import axios from 'axios'
import { isIosAppUserAgent } from '~/utils/userAgent'
import { isOneSignalAllowedHost } from '~/config/oneSignal'

async function check(store, gtm) {
  // ログイン時のみ対応
  if (store.getters['auth/isLogin']) {
    // ユーザーID送信
    // https://qiita.com/TK-C/items/401dc403c6f3af6ad086
    // gtm.push({ user_id: store.state.auth.company.uid })

    // デターの同期チェック
    store.dispatch('auth/mstCheckUpdate')

    // oneSignal
    store.dispatch('auth/updateOneSignalDeviseToken')
  } // ログイン

  // アプリ・バージョンアップ
  try {
    // version.jsonファイルから最新のバージョンを取得（キャッシュバスティング）
    const res = await axios.get('/version.json', {
      headers: { 'Cache-Control': 'no-cache' },
      params: { _t: Date.now() }
    })
    const data = res.data
    const latestVersion = data.version

    // 環境変数から現在のバージョンを取得
    const curVersion = !!process.env.VERSION ? Number(process.env.VERSION) : 0

    // 最新バージョンよりも古かったら、強制的にリロードする
    // 同じバージョンで既にリロード済みなら無限ループ防止のためスキップ
    if (curVersion < latestVersion) {
      const RELOAD_FLAG = 'version_update_reload'
      try {
        const savedVersion = sessionStorage.getItem(RELOAD_FLAG)
        if (savedVersion === String(latestVersion)) {
          console.warn(`Already reloaded for version ${latestVersion}, skipping`)
          return
        }
        sessionStorage.setItem(RELOAD_FLAG, String(latestVersion))
      } catch {
        // sessionStorageが使えない場合はリロードせずスキップ（ループ防止）
        console.warn('sessionStorage unavailable, skipping reload')
        return
      }
      console.log(`Version update detected: ${curVersion} -> ${latestVersion}`)
      window.location.reload()
    }
  } catch (error) {
    console.error(error)
    // エラーのときはなにもしない
  }
}

// Push の購読状態を見て、端末 ID を localStorage に残す（store/auth.js の updateOneSignalDeviseToken がサーバへ送る）
function subscribeOneSignal() {
  console.log('start get Onesignal')
  $OneSignal.push(async () => {
    console.log('start Onesignal subscriptionChange')
    await $OneSignal.on('subscriptionChange', async isSubscribed => {
      console.log('Onesignal subscriptionChange done', isSubscribed)
      if (isSubscribed) {
        const deviceId = await $OneSignal.getUserId()
        console.log('onesignel deviceId', deviceId)
        localStorage.setItem('onesignal_user_id', deviceId)
      } else {
        $OneSignal.showNativePrompt()
      }
    })
  })
  $OneSignal.push(async () => {
    console.log('start Onesignal isPushNotificationsEnabled')
    await $OneSignal.isPushNotificationsEnabled(async isEnabled => {
      console.log('Onesignal isPushNotificationsEnabled done', isEnabled)
      if (isEnabled) {
        const deviceId = await $OneSignal.getUserId()
        console.log('onesignel deviceId', deviceId)
        localStorage.setItem('onesignal_user_id', deviceId)
      } else {
        $OneSignal.showNativePrompt()
      }
    })
  })
}

// まずSettimeoutで初期チェック、その後1分毎に自動チェック
export default async ({ store, route, query, $gtm }) => {
  // 起動1秒後実行
  window.setTimeout(async () => {
    // useragent
    const ua = navigator.userAgent
    let isIosApp = isIosAppUserAgent(ua)
    store.commit('userAgent/set', { isIosApp: isIosApp, ua: ua })
    let isTouchDevice = false
    if (/android/i.test(ua)) isTouchDevice = true
    if (/iPad|iPhone|iPod/i.test(ua) || isIosApp) isTouchDevice = true
    store.commit('devise/setIsTouchDevice', isTouchDevice)

    // ログインしていたらマスタの更新
    if (store.getters['auth/isLogin']){
      store.dispatch('auth/refreshToken')
      store.dispatch("auth/mstForceUpdate")
    }

    // update old
    store.commit("auth/updateOldDate")
  }, 1000)

  // 起動4秒後実行
  window.setTimeout(async () => {
    // onesignal（cp.gyms.jp でだけ。ほかのホストでは init していない。config/oneSignal.js）
    if (isOneSignalAllowedHost(window.location.hostname)) subscribeOneSignal()

    // 諸々のチェック
    check(store, $gtm)
  }, 1000 * 4)

  // 5分に1回
  window.setInterval(
    () => {
      check(store)
    },
    1000 * 60 * 5
  )
}
